import React, { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import { Col, Container } from '@yme/atoms/grid';
import { useWindowSize } from '@yme/common/hooks';
import { getHasContentHeroIndent } from '@yme/components/ContentPage/components/HeroSection/redux/selectors';
import { FAQContent } from '@yme/components/FAQContent';
import { getMarginTopForFAQ } from '@yme/components/FaqMainContent/helpers';
import { IndentWrapper } from '@yme/components/Separator';
import { getRTL } from '@yme/selectors/common';
import { useTranslation } from '@yme/services/i18n';
import { colorCoreWhite1000 } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { NoLuckComponent } from './NoLuckComponent';
import { TopicComponent } from './TopicComponent';
import { FAQ_DATA_TEST_ID } from './constants';
import { ColStyled, RowStyled, SideBarStyled } from './styled';
export function FaqMainContent(props) {
    const { isRemoveBottomIndent, sections, linksPanelTitle, linksPanelDescription, contactUsPanelTitle, contactUsPanelDescription, messageUsButton, } = props;
    const [activeItem, setActiveItem] = useState('');
    const { isInfiniteDesktopView } = useWindowSize();
    const hasContentHeroIndent = useSelector(getHasContentHeroIndent);
    const { t } = useTranslation();
    const isRightToLeft = useSelector(getRTL);
    const chooseQuestionOnClick = useCallback((event) => {
        const target = event.target;
        const isButtonClicked = target.closest('button') !== null;
        if (isButtonClicked) {
            setActiveItem(event.currentTarget.id);
        }
    }, [setActiveItem]);
    if (sections?.length === 0) {
        return null;
    }
    return (React.createElement(IndentWrapper, { isRemoveBottomIndent: isRemoveBottomIndent },
        React.createElement(Container, { isRightToLeft: isRightToLeft, dataTestId: FAQ_DATA_TEST_ID },
            React.createElement(RowStyled, { mt: getMarginTopForFAQ(isInfiniteDesktopView, hasContentHeroIndent) },
                React.createElement(ColStyled, { lg: 4 },
                    React.createElement(SideBarStyled, { flexDirection: "column", gap: "24px" },
                        React.createElement(TopicComponent, { headerLabel: linksPanelTitle, description: linksPanelDescription, sections: sections, activeItem: activeItem, setActiveItem: setActiveItem, isRightToLeft: isRightToLeft, backToTopicsLabel: t('faq_backToTopics_label') }),
                        contactUsPanelTitle && (React.createElement(NoLuckComponent, { contactUsPanelTitle: contactUsPanelTitle, contactUsPanelDescription: contactUsPanelDescription, messageUsButton: messageUsButton })))),
                isInfiniteDesktopView && (React.createElement(Col, { lg: 8 },
                    React.createElement(FlexWrapper, { bg: colorCoreWhite1000, flexDirection: "column", paddingDesktop: "48px" },
                        React.createElement(FAQContent, { onClick: chooseQuestionOnClick, isRightToLeft: isRightToLeft, sections: sections, pbDesktop: "56px" }))))))));
}
FaqMainContent.displayName = 'FaqMainContent_AEMComponent';
